import React, { Component } from 'react';
import '../css/footer.css';
import { LanguageContext } from '../contexts/LanguageContext';

class Footer extends Component {
    static contextType = LanguageContext;
    state = {  } 
    render() { 
        const { translations } = this.context;
        return (
            <section className='footer-section'>
                <footer>{translations?.footer_main_text}<p>-</p><span>{translations?.footer_secondary_text}</span></footer>
            </section>
        );
    }
}
 
export default Footer;